import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { NOTIFICATION_TYPE } from '../../../../../../constants/common'

import { LISTING_PORTALS_ERROR_NOTIFICATION_ID } from './useRentalPortalListingsFormPortalsErrorNotification.constants'

import RefreshIcon from '../../../../../../icons/refresh.svg'

export function useRentalPortalListingsFormPortalsErrorNotification({
  hasPortalsError,
  onReloadPortals,
  onRemoveNotification,
  onSetNotification,
}) {
  const { t } = useTranslation()

  useEffect(() => {
    if (hasPortalsError) {
      onSetNotification({
        actions: [
          {
            beforeIconProps: { Icon: RefreshIcon },
            callback: onReloadPortals,
            text: t('RentalPortal.ListingRetryBtnKey'),
          },
        ],
        id: LISTING_PORTALS_ERROR_NOTIFICATION_ID,
        text: t('RentalPortal.ListingFormPortalsLoadErrorKey'),
        type: NOTIFICATION_TYPE.error,
      })
    } else {
      onRemoveNotification(LISTING_PORTALS_ERROR_NOTIFICATION_ID)
    }
  }, [hasPortalsError])
}
